<template>
  <div>
    <label  class="labelTitle" v-if="label">
      {{ label }}
      <BaseRequiredField v-if="isMandatory" />
      <span v-if="isLoading"><font-awesome-icon :icon="['fas', 'spinner']" spin size="sm" /></span>
    </label>
    <div class="selectStyle">
      <select required
        class="form-control"
        :class="{ 'is-invalid': validator ? validator.$error : '', 'form-control-sm':  isSmallSize, 'form-control-lg':  isLargeSize }"
        @input="updateValue"
        :value="value"
        v-bind="$attrs">
        <option disabled hidden value="select" :selected="value === 0">Select</option>
        <option
          v-for="(option, index) in options"
          :key="index"
          :value="option.value"
          :selected="option.value === value">
          {{ option.text }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSelect',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    isMandatory: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Object,
      required: false
    },
    value: [String, Number],
    isSmallSize: {
      type: Boolean,
      default: false
    },
    isLargeSize: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>

<style>
select:invalid { color: gray; }
</style>
